import * as Yup from "yup";


export let addProduct = Yup.object({
   title: Yup.string().required("Title is Required.").min(2, "Title Must be greater then 1 characters."),
   description: Yup.string().required("Description is Required."),
   image: Yup.string().required("Product primary picture is Required."),
   sellPrice: Yup.number().required("Price is required.").typeError("Price should be a number."),
   oldPrice: Yup.number().required("Old price is required.").typeError("Old price should be a number."),
   cost: Yup.number().required("Cost is required.").typeError("Cost should be a number."),
   stockInHand: Yup.number().required("Stock in hand is required.").typeError("Stock in hand should be a number."),
   physicalState: Yup.boolean().required("Physical state is required."),
   weight: Yup.number().when('physicalState', { is: true, then: () => Yup.number().typeError("Weight must be a number.").required('Weight is required.') }),
   height: Yup.number().when('physicalState', { is: true, then: () => Yup.number().typeError("Height must be a number.").required('Height is required.') }),
   width: Yup.number().when('physicalState', { is: true, then: () => Yup.number().typeError("Width must be a number.").required('Width is required.') }),
   length: Yup.number().when('physicalState', { is: true, then: () => Yup.number().typeError("Length must be a number.").required('Length is required.') }),
   optionsTitle: Yup.string().when('multiPrices', {
      is: true,
      then: () => Yup.string().required("Multi price title is required.").min(2, "Multi price title must be at least 2 characters.")
   }),
   multiPriceList: Yup.array().when('multiPrices', {
      is: true,
      then: () => Yup.array().min(1, "At least one price option is required.")
   }),
   customInputTitle: Yup.string().when('customInput', {
      is: true,
      then: () => Yup.string().required("Custom input title is required.").min(2, "Custom input title must be at least 2 characters.")
   }),
   metaTitle: Yup.string().required("Meta title is required.").min(2, "Meta title must be at least 2 characters."),
   metaDesc: Yup.string().required("Meta description is required.").min(2, "Meta description must be at least 2 characters."),
});

export let multiPricesForm = Yup.object({
   title: Yup.string().required("Title is Required.").min(2, "Must be greater then 1 characters."),
   sellPrice: Yup.number().required("Price is required.").typeError("Price should be a number."),
   oldPrice: Yup.number().required("Old price is required.").typeError("Old price should be a number."),
   cost: Yup.number().required("Cost is required.").typeError("Cost should be a number."),
   stockInHand: Yup.number().required("Stock in hand is required.").typeError("Stock in hand should be a number."),

});